import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

const BreadCrumbMaker = ({ items }) => {
  if (!items.length) return null;
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Breadcrumb
      fontSize="lg"
      fontWeight="bold"
      mb={4}
      separator={
        <Text mx={1} color="gray.400">
          /
        </Text>
      }
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1 && items.length > 1;
        const isActiveParent =
          items.length > 1 && !isLast && location.pathname === item.link;

        return (
          <BreadcrumbItem key={`${item.link}-${index}`}>
            <BreadcrumbLink
              as="span"
              cursor={isLast ? "default" : "pointer"}
              color={isLast ? "#396AFF" : "black"}
              textDecoration={isActiveParent ? "underline" : "none"}
              textUnderlineOffset="4px"
              textDecorationThickness="2px"
              _hover={{
                textDecoration: isLast ? "none" : "underline",
              }}
              onClick={() => {
                if (!isLast) navigate(item.link);
              }}
            >
              {item.title}
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

BreadCrumbMaker.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default BreadCrumbMaker;
